import { defineMessages } from 'react-intl';

/** The copy of step 5 "Start" (design outreach-v2 f1, f2). */
export const startMessages = defineMessages({
  modeTitle: { id: 'app.outreach.start.mode.title', defaultMessage: 'How pitches go out' },
  modeReview: { id: 'app.outreach.start.mode.review', defaultMessage: 'I read each pitch' },
  modeReviewSub: {
    id: 'app.outreach.start.mode.reviewSub',
    defaultMessage:
      "Every morning today's {rate} pitches wait for you. Approve, edit or skip. A pitch you do not approve does not go and does not count.",
  },
  modeAutopilot: { id: 'app.outreach.start.mode.autopilot', defaultMessage: 'Autopilot' },
  modeAutopilotSub: {
    id: 'app.outreach.start.mode.autopilotSub',
    defaultMessage:
      'Plug checks each pitch against the rules and sends the ones that pass. You read them after, on the campaign page.',
  },
  modeLabelChip: { id: 'app.outreach.start.mode.labelChip', defaultMessage: 'Ultra' },
  modeAutopilotOffer: {
    id: 'app.outreach.start.mode.autopilotOffer',
    defaultMessage: 'Pitch {label} a day with autopilot on Ultra',
  },

  timingTitle: { id: 'app.outreach.start.timing.title', defaultMessage: 'Timing' },
  windowTitle: { id: 'app.outreach.start.window.title', defaultMessage: 'Their morning' },
  windowSub: {
    id: 'app.outreach.start.window.sub',
    defaultMessage: "Each pitch goes between {start}:00 and {end}:00 in the person's time zone.",
  },
  windowSubWeekdays: {
    id: 'app.outreach.start.window.subWeekdays',
    defaultMessage:
      "Each pitch goes Monday to Friday, between {start}:00 and {end}:00 in the person's time zone. A pitch that Plug writes on a Saturday or Sunday waits for Monday.",
  },
  weekdays: { id: 'app.outreach.start.window.weekdays', defaultMessage: 'Weekdays' },
  everyDay: { id: 'app.outreach.start.window.everyDay', defaultMessage: 'Every day' },
  followTitle: { id: 'app.outreach.start.follow.title', defaultMessage: 'One follow-up after {days} days' },
  followSub: {
    id: 'app.outreach.start.follow.sub',
    defaultMessage:
      'Only when they did not listen and did not answer. It adds one new fact, like "out now". Free: it does not count as a pitch.',
  },
  followLabel: { id: 'app.outreach.start.follow.label', defaultMessage: 'Send one follow-up' },
  endTitle: { id: 'app.outreach.start.end.title', defaultMessage: 'Runs until {date}' },
  endTitleOpen: { id: 'app.outreach.start.end.titleOpen', defaultMessage: 'Runs until you stop it' },
  endSub: {
    id: 'app.outreach.start.end.sub',
    defaultMessage: '{weeks} weeks after the release. Plug stops earlier when no new good fits are left.',
  },
  endSubOpen: {
    id: 'app.outreach.start.end.subOpen',
    defaultMessage: 'Plug stops when no new good fits are left, or when you stop it.',
  },
  endWeeks: { id: 'app.outreach.start.end.weeks', defaultMessage: '{weeks} weeks after release' },
  endNever: { id: 'app.outreach.start.end.never', defaultMessage: 'Until I stop it' },
  endLabel: { id: 'app.outreach.start.end.label', defaultMessage: 'When the campaign ends' },
  windowLabel: { id: 'app.outreach.start.window.label', defaultMessage: 'Days that pitches go out' },
  tellTitle: { id: 'app.outreach.start.tell.title', defaultMessage: 'Tell me' },
  tellSub: {
    id: 'app.outreach.start.tell.sub',
    defaultMessage: 'A push for each reply and each new playlist add. One email a day with what Plug did.',
  },
  tellChange: { id: 'app.outreach.start.tell.change', defaultMessage: 'Change' },

  recapSong: { id: 'app.outreach.start.recap.song', defaultMessage: 'Song' },
  recapSongValue: { id: 'app.outreach.start.recap.songValue', defaultMessage: '{song} · out {date}' },
  recapWho: { id: 'app.outreach.start.recap.who', defaultMessage: 'Who' },
  recapWhoValue: {
    id: 'app.outreach.start.recap.whoValue',
    defaultMessage: '{kinds, plural, one {# kind} other {# kinds}} · {fit} fit now',
  },
  recapPerDay: { id: 'app.outreach.start.recap.perDay', defaultMessage: 'Per day' },
  recapPerDayWarmup: { id: 'app.outreach.start.recap.perDayWarmup', defaultMessage: '{rate} ({cap} in the warm-up)' },
  recapMessage: { id: 'app.outreach.start.recap.message', defaultMessage: 'Message' },
  recapFrom: { id: 'app.outreach.start.recap.from', defaultMessage: 'From' },
  recapNever: { id: 'app.outreach.start.recap.never', defaultMessage: 'Never contact' },
  recapNeverValue: { id: 'app.outreach.start.recap.neverValue', defaultMessage: '{count} added' },
  recapEdit: { id: 'app.outreach.start.recap.edit', defaultMessage: 'Edit' },
  recapNone: { id: 'app.outreach.start.recap.none', defaultMessage: '—' },

  startButton: { id: 'app.outreach.start.button', defaultMessage: 'Start pitching' },
  // "Edit setup" of a running campaign: every step saved on change.
  saveButton: { id: 'app.outreach.start.save', defaultMessage: 'Save changes' },
  barEditing: { id: 'app.outreach.start.barEditing', defaultMessage: 'Plug keeps pitching with these changes' },
  barEditingSub: {
    id: 'app.outreach.start.barEditingSub',
    defaultMessage: 'The new setup applies to the pitches that Plug writes next. Sent pitches stay as they are.',
  },
  saved: { id: 'app.outreach.start.saved', defaultMessage: 'Your changes are saved.' },
  seePlans: { id: 'app.outreach.start.seePlans', defaultMessage: 'See plans' },
  barReview: { id: 'app.outreach.start.bar.review', defaultMessage: 'Plug starts looking tonight' },
  barReviewSub: {
    id: 'app.outreach.start.bar.reviewSub',
    defaultMessage: 'Your first pitches wait for you on the next weekday morning, at 8:00.',
  },
  barAutopilot: {
    id: 'app.outreach.start.bar.autopilot',
    defaultMessage: 'Plug starts tonight: {rate} a day on autopilot',
  },
  barAutopilotSub: {
    id: 'app.outreach.start.bar.autopilotSub',
    defaultMessage: 'The first pitches go on the next weekday morning. You read them on the campaign page.',
  },
  barFree: { id: 'app.outreach.start.bar.free', defaultMessage: 'Your setup is saved' },
  barFreeSub: {
    id: 'app.outreach.start.bar.freeSub',
    defaultMessage:
      'Plug found {count, plural, one {# person} other {# people}} who fit {song}. Pick a plan and Plug starts tonight.',
  },
  barTrial: {
    id: 'app.outreach.start.bar.trial',
    defaultMessage: 'Your trial pitches {rate, plural, one {# person} other {# people}} a day',
  },
  barTrialSub: {
    id: 'app.outreach.start.bar.trialSub',
    defaultMessage: 'Real pitches until the trial ends. Then {artist} a day on Plus, {pro} on Pro, {label} on Ultra.',
  },
  barNeedsMailbox: { id: 'app.outreach.start.bar.needsMailbox', defaultMessage: 'Pick a mailbox in step 4 first.' },
  warmupNote: {
    id: 'app.outreach.start.warmupNote',
    defaultMessage:
      '{address} is on day {day} of the warm-up. {song} starts with {cap} a day and reaches your {rate} a day on {date}.',
  },
  startFailed: { id: 'app.outreach.start.failed', defaultMessage: 'Plug could not start the campaign. Try again.' },
  startNoMailbox: {
    id: 'app.outreach.start.noMailbox',
    defaultMessage: 'Connect a mailbox that can send, or resume a paused one.',
  },
  startedToday: {
    id: 'app.outreach.start.startedToday',
    defaultMessage: 'Plug started. {count, plural, one {# pitch} other {# pitches}} for today.',
  },
  startedTonight: { id: 'app.outreach.start.startedTonight', defaultMessage: 'Plug started. It looks tonight.' },
  startedPicked: {
    id: 'app.outreach.start.startedPicked',
    defaultMessage: 'Plug started and picked {count, plural, one {# person} other {# people}}. See who on Today.',
  },
});
